import slice, { setForm, setStatus } from './company.slice';
export { setForm, setStatus };
export default slice.reducer;
